var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('b-button',{staticClass:"rounded-pill vetro-vue-component-library__cta-button",attrs:{"disabled":_vm.isDisabled,"variant":"outline-primary","size":"lg"},on:{"click":function($event){return _vm.$emit('buttonClicked')}}},[_c('font-awesome-icon',{staticClass:"mr-2",attrs:{"icon":"plus"}}),_vm._v(" "+_vm._s(_vm.text)+" ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }